export function driveFolderUrl(folderId) {
  const id = String(folderId || '').trim();
  if (!id) {
    return null;
  }
  return `https://drive.google.com/drive/folders/${encodeURIComponent(id)}`;
}

/** Resolves a stored Drive folder id or folder URL to a browser href. */
export function resolveGoogleDriveHref(path) {
  const trimmed = String(path || '').trim();
  if (!trimmed) {
    return null;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return driveFolderUrl(trimmed);
}
